import { Drawer } from "@mui/material";
import React from "react";

const SlideOver = ({ open, onClose, children, width }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": { width: width || "95vw" },
      }}
      transitionDuration={600}
    >
      {children}
    </Drawer>
  );
};

export default SlideOver;
